export const APPROVE = "Aprobar archivo";
export const SEND_TO_REVIEW = "Enviar a revisión";
